import React from 'react'
import { ReactTypeformEmbed } from 'react-typeform-embed'

class AmbassadorSurvey extends React.Component {
  render() {
    return (
      <ReactTypeformEmbed url="https://justmote.typeform.com/to/vTOtWwMZ" />
    )
  }
}

export default AmbassadorSurvey
